import { render } from "./rank.vue?vue&type=template&id=67d57a8e&scoped=true"
import script from "./rank.vue?vue&type=script&lang=js"
export * from "./rank.vue?vue&type=script&lang=js"

import "./rank.vue?vue&type=style&index=0&id=67d57a8e&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d57a8e"]])

export default __exports__